import { render, staticRenderFns } from "./EditSalesPerson.vue?vue&type=template&id=c5a3d00e"
import script from "./EditSalesPerson.vue?vue&type=script&lang=ts"
export * from "./EditSalesPerson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports